"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var folder_1 = require("owa-service/lib/factory/folder");
var folderId_1 = require("owa-service/lib/factory/folderId");
var updateFavoriteFolderRequest_1 = require("owa-service/lib/factory/updateFavoriteFolderRequest");
var updateFavoriteFolderOperation_1 = require("owa-service/lib/operation/updateFavoriteFolderOperation");
/**
 * Configure the request body for updateFavoriteFolderOperation
 * @param currentFolder the current folder to be updated
 * @param isAdd whether the operation is an add or remove operation
 */
function configureRequest(currentFolder, isAdd) {
    var targetFolderId = folderId_1.default({
        Id: currentFolder.FolderId.Id,
        ChangeKey: currentFolder.FolderId.ChangeKey,
    });
    var request = updateFavoriteFolderRequest_1.default({
        Folder: folder_1.default({
            FolderId: targetFolderId,
            DisplayName: currentFolder.DisplayName,
        }),
        Operation: isAdd ? 0 /* Add */ : 1 /* Remove */,
    });
    return request;
}
/**
 * Sends out the service request to add or remove the a favorite in favorite store
 * @param currentFolder the current folder to be updated
 * @param isAdd whether the operation is an add or remove operation
 * @return a promise that contains UpdateFavoriteFolderResponse
 */
function addRemoveFavoriteService(currentFolder, isAdd) {
    var requestBody = configureRequest(currentFolder, isAdd);
    // TODO: Task 314: Make this not throw an HTTP 500 error on the server
    return updateFavoriteFolderOperation_1.default({
        request: requestBody,
    }).then(function (response) {
        return response;
    });
}
exports.default = addRemoveFavoriteService;
//# sourceMappingURL=addRemoveFavoriteService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-favorites-store/lib/services/addRemoveFavoriteService.js
// module id = 3164
// module chunks = 14 68